/* eslint-disable import/prefer-default-export */
import { IdentityTileType } from '@src/endpoints/services/graphQueryMgr.service'
export enum IdentityTiles {
  objects = 'Data',
  privileges = 'Privileges',
  userPrivileges = 'UserPrivileges',
  instances = 'Instances',
  members = 'Members',
  users = 'Users',
  roles = 'Roles',
  violations = 'Violations',
  scopes = 'Scopes'
}

export enum IdentityTileCounter {
  total = 'total',
  used = 'used',
  normal = 'normal'
}

export const NameTileCounterByType = {
  [IdentityTileCounter.total]: 'Total',
  [IdentityTileCounter.used]: 'Used'
}

export const NameTilesByType = {
  [IdentityTiles.objects]: 'Objects',
  [IdentityTiles.violations]: 'Alerts',
  [IdentityTiles.roles]: 'Roles',
  [IdentityTiles.users]: 'Users',
  [IdentityTiles.privileges]: 'Privileges',
  [IdentityTiles.userPrivileges]: 'Privileges',
  [IdentityTiles.members]: 'Members',
  [IdentityTiles.instances]: 'Instances',
  [IdentityTiles.scopes]: 'Scopes'
}

export const mapTileToTileType = {
  [IdentityTiles.objects]: IdentityTileType.TILE_OBJECT,
  [IdentityTiles.members]: IdentityTileType.TILE_MEMBER,
  [IdentityTiles.userPrivileges]: IdentityTileType.TILE_PRIVILEGE,
  [IdentityTiles.users]: IdentityTileType.TILE_USER,
  [IdentityTiles.instances]: IdentityTileType.TILE_INSTANCE,
  [IdentityTiles.scopes]: IdentityTileType.TILE_SCOPE,
  [IdentityTiles.roles]: IdentityTileType.TILE_ROLE,
  [IdentityTiles.privileges]: IdentityTileType.TILE_PRIVILEGE
}
